// extracted by mini-css-extract-plugin
export default {"manageNavigation":"ManageNavigation_manageNavigation__f+h+x"};